import { render } from "./DashbordsCalendar.vue?vue&type=template&id=239f9933"
import script from "./DashbordsCalendar.vue?vue&type=script&lang=js"
export * from "./DashbordsCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__